








































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import left from '@/assets/left-flair.svg';
import _ from 'lodash';

export interface MelosToggleOption {
  label: string;
  active: boolean;
}

@Component
export default class MelosMultipleToggle extends Vue {
  @Prop() private options!: MelosToggleOption[];
  @Prop() private equalOptionSize!: boolean;

  private clickedIndex: number = -1;

  private get isFirstActive(): boolean {
    if (this.options.length === 0) {
      return false;
    }
    return this.options[0].active || this.clickedIndex === 0;
  }

  private get isLastActive(): boolean {
    if (this.options.length === 0) {
      return false;
    }
    return this.options[this.options.length - 1].active ||
    this.clickedIndex === this.options.length - 1;
  }

  private optionClickStart(index: number) {
    this.clickedIndex = index;
  }

  private optionClickEnd(index: number) {
    this.clickedIndex = -1;
  }

}

